export const APP_NAME = "WeightPlanner Pro";
export const APP_DOMAIN = "weightplanner.fit";
export const APP_TAGLINE = "Physics-based planning for cut, bulk & maintenance.";
